export * from "./TriviaScore";
